/**
 * @generated SignedSource<<316873462d81660513b39d3d9a706212>>
 * @relayHash eacc72b6f9ecbeb5ab52a1b74d6064a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4b8a86e7d74a33ca56fd7bd765cf5fe7190dcc5b4651d4e2fc4666574c7cc9b4

import type { ConcreteRequest } from 'relay-runtime';
export type BreadcrumbsDropdownContentQuery$variables = {
  contentId?: string | null;
  skipContent: boolean;
  spaceKey: string;
};
export type BreadcrumbsDropdownContentQuery$data = {
  readonly content?: {
    readonly nodes: ReadonlyArray<{
      readonly ancestors: ReadonlyArray<{
        readonly id: string | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly status: string | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly id: string | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly status: string | null;
      readonly subType: string | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
  readonly space: {
    readonly alias: string | null;
    readonly homepage: {
      readonly id: string | null;
    } | null;
    readonly icon: {
      readonly path: string;
    } | null;
    readonly id: string | null;
    readonly name: string | null;
  } | null;
};
export type BreadcrumbsDropdownContentQuery = {
  response: BreadcrumbsDropdownContentQuery$data;
  variables: BreadcrumbsDropdownContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipContent"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "type"
},
v5 = {
  "kind": "ScalarField",
  "name": "subType"
},
v6 = {
  "kind": "ScalarField",
  "name": "status"
},
v7 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v3/*: any*/),
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "kind": "ScalarField",
        "name": "value"
      }
    ]
  }
],
v8 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "alias"
      },
      (v3/*: any*/),
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "path"
          }
        ]
      },
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ]
      }
    ]
  },
  {
    "condition": "skipContent",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
          },
          {
            "kind": "Literal",
            "name": "status",
            "value": [
              "current",
              "draft",
              "archived"
            ]
          }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "keys",
                    "value": [
                      "emoji-title-published",
                      "emoji-title-draft"
                    ]
                  }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
              },
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "title"
                  },
                  (v6/*: any*/),
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "keys",
                        "value": [
                          "emoji-title-published"
                        ]
                      }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": "properties(keys:[\"emoji-title-published\"])"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "BreadcrumbsDropdownContentQuery",
    "selections": (v8/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "BreadcrumbsDropdownContentQuery",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "eacc72b6f9ecbeb5ab52a1b74d6064a5",
    "id": "4b8a86e7d74a33ca56fd7bd765cf5fe7190dcc5b4651d4e2fc4666574c7cc9b4",
    "metadata": {},
    "name": "BreadcrumbsDropdownContentQuery",
    "operationKind": "query",
    "text": "query BreadcrumbsDropdownContentQuery($spaceKey:String!,$contentId:ID,$skipContent:Boolean!){space(key:$spaceKey){alias,id,name,icon{path},homepage{id}},content(id:$contentId,status:[\"current\",\"draft\",\"archived\"])@skip(if:$skipContent){nodes{id,type,subType,status,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value}},ancestors{id,type,subType,title,status,properties(keys:[\"emoji-title-published\"]){nodes{id,key,value}}}}}}"
  }
};
})();

(node as any).hash = "3e4a9d4b445d7d646b220e3bab421884";

export default node;
